import { render, staticRenderFns } from "./create-or-edit-view-action.vue?vue&type=template&id=5e6335c7&"
import script from "./create-or-edit-view-action.ts?vue&type=script&lang=js&"
export * from "./create-or-edit-view-action.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports